// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"36fe8000","455":"68f3788f","977":"519f0783"}[chunkId] + ".chunk.js";
};